import * as React from 'react';
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";
import {useNavigate,useParams } from 'react-router-dom';
import firebase from "../../firebase/firebase";
import Stack from "@mui/material/Stack/Stack";
import {AuthUserContext} from "../../providers/AuthProvider";
import Avatar from "@mui/material/Avatar/Avatar";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';import {useContext} from "react";
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import TextField from "@mui/material/TextField/TextField";
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import IconButton from "@mui/material/IconButton/IconButton";

import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import {LinearProgress, styled} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import ChatMediaTabs from "../../components/ChatMediaTabs";
import TextMessageComponent from "../../components/TextMessageComponent";
import MediaFileMessageComponent from "../../components/MediaFileMessageComponent";
import FileMessageComponent from "../../components/FileMessageComponent";
import LinkMessageComponent from "../../components/LinkMessageComponent";
import Box from "@mui/material/Box";
import PostNotification from "../../helpers/post-notification";
import Spinner from '../../components/spinner';
import PostActivity from "../../helpers/post-activity";
export default function Chats() {
  const navigator = useNavigate();

  const storageRef = firebase.storage().ref();
  const [rooms, setRooms] = React.useState([]);
  const [noRooms, setNoRooms] = React.useState(true)
  const [messages, setMessages] = React.useState([]);
  const [selectedRoom, setSelectedRoom] = React.useState();
  const [textInput, setTextInput] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [preview, setPreview] = React.useState(false);
  const [showTabs, setShowTabs] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState();
  const [loading, setLoading] = React.useState(true);
  let selectedRoomCopy;
       // end position of listener
  const setRom = (room) => {
    console.log(`RoomID: ${room?.id}`)
    selectedRoomCopy = room
    setSelectedRoom(room);
  }
  React.useEffect(() => {

    let unsubscribe;
    const roomRef = firebase.firestore().collection("rooms")
      .orderBy("updatedAt", "desc");
     unsubscribe = roomRef
       .where("participates", "array-contains", profile?.uid)
       .onSnapshot( async (snapshot) =>{

         const roomSelect = selectedRoomCopy
         if (snapshot?.size > 0) {
           const list =[]
           for(let snap of snapshot?.docs) {
             const users = await firebase.firestore().collection('users')
               .where('uid',  '==',  snap.data()?.participates.find((f) => f !== profile.uid))
               .get();
             let image;
             if (users?.docs[0]?.data().avatar) {
               image = await downloadURL(users?.docs[0]?.data().avatar)
             }
             list.push({id: snap.id, ...snap.data(), image, participate: users?.docs[0]?.data().name});
             if (list.length === snapshot.size) {
               setRooms(list)
               setNoRooms(false)
               if (selectedRoomCopy === undefined) {
                 setRom(list[0]);
                }
              }
              
            }
          }
          if (messages.length===0){
            setNoRooms(false)
          }
        }
        )
    return () => {
      unsubscribe()
    };
  }, [])

  const imgExtPattern = /.gif|.png|.jpg/
  const videoExtPattern = /.mp4|.ogg|.webm/
  React.useEffect(() => {

    let unsubscribe;
    const roomRef =firebase.firestore()
      .collection('messages')
      .orderBy("createdAt", "desc");
    unsubscribe = roomRef
      .where('roomId', '==', selectedRoom ? selectedRoom?.id : '0')
      .onSnapshot((snapshots) => {
        const msgs = []
        if (snapshots && snapshots.docs && snapshots.docs.length > 0) {
          snapshots.docs.forEach(async (msg) => {
            let uri ;
            if (msg?.data()?.file) {
              uri = await downloadURL(msg?.data()?.file)
            }
            if (msg.data().receiver === profile?.uid && msg.data().read === false) {
              setTimeout(async () => await firebase.firestore().collection('messages').doc(msg.id).update({
                read: true,
                status: 'seen'
              }) , 1000);
            }
            msgs.push({id:msg.id,...msg.data(), uri})
            if (msgs.length === snapshots.docs.length) {
              setMessages(msgs.sort((a, b) => new Date(a.createdAt.seconds * 1000) - new Date(b.createdAt.seconds * 1000)))

              setTimeout(() =>  document.getElementById("msg-container").scrollTo({
                top: document.getElementById("msg-container").scrollHeight,
                behavior: 'smooth',
              }), 500)
            }

          })

        } else {
          setMessages(msgs)

        }
      })
    return () => {
      unsubscribe()
    };
    
  }, [selectedRoom])

  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

// Get the download URL
    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
        // setImageUrl(url)
        // setLoading(false)
        // Insert url into an <img> tag to "download"
      })
      .catch((error) => {
        reject(error)
        // setLoading(false)

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
  }))
  const [ml, setML] = React.useState(false)
  const [cl, setCL] = React.useState(false)
  const [al, setAL] = React.useState(false)
  const getAllMedia = async (type) => {
    if (selectedRoom) {

      const files = await storageRef.child(`chats/${selectedRoom.id}/media/`)
        .listAll()
      console.log(files.items[0].name, 'name')
      //


    }

  }
  const uploadFile =  (type, files) => {
    const file = files;
    const path = `chats/${selectedRoom.id}/${type}/${file.name}`
    const uploadTask = storageRef.child(path)
      .put(file);
    if (type === 'media') setML(true);
    if (type === 'contract') setCL(true);
    if (type === 'attachment') setAL(true);
    setPreview(false)
    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      },
      (error) => {
      },
      async () => {
        if (type === 'media') setML(false);
        if (type === 'contract') {
          //
          setCL(false)
          const contractRef = firebase.firestore().collection('contracts').doc(selectedRoom?.contractId);
          const contract =await contractRef.get()
          const signContract = contract?.data()?.signContract ? contract?.data()?.signContract :  {};
          if (profile?.userType === 'investor') {
            signContract.investor = path
          } else if (profile?.userType === 'creator'){
            signContract.creator = path
          } else {
            signContract.artist = path
          }
          await contractRef.update({
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            signContract, status:profile?.userType === 'investor'? 'investor-signed-contract' : profile?.userType === 'artist'? 'artist-signed-contract' : 'creator-signed-contract'
          })
          /*Super Admin Notification*/
          const projectRef = await firebase
            .firestore()
            .collection('projects')
            .doc(selectedRoom?.projectId).get();
          const project = {id: projectRef.id, ...projectRef.data()}
          const stateObject = {state: {project, tab: 1}};
          const postId = await PostNotification({
            title: 'Sign contract',
            text: 'A new celebrated contract is pending approval. Click here to review it.',
            uid: null,
            createdBy:'self',
            showing:['super'],
            link: '/admin/project-management',
            state: JSON.stringify(stateObject)
          });
          console.log(`Notify Admin ${postId}`)
          /*
          * You have submitted the signed contract to “James Burrows”
          * */
          PostActivity({
            text: profile?.userType === 'creator'? `You have submitted the signed contract to ${selectedRoom?.participate}` :`You have successfully send signed contract for project "${project?.title}"`,
            uid: profile.uid,
            createdBy:profile?.uid
          }).then()
          profile?.userType === 'investor' ? setOpen(true) : setOpen(false);/*TODO: creator action?*/

        }
        if (type === 'attachment') setAL(false);

        const msgRef = firebase.firestore().collection('messages');
        const postMsg = {
          text: textInput,
          type: type,
          file: path,
          sender: profile?.uid,
          receiver: selectedRoom.participates.find((d) => d !== profile?.uid),
          createdAt:firebase.firestore.FieldValue.serverTimestamp(),
          roomId: selectedRoom.id,
          read:false,
          status: 'send'
        }
        const addmsg = await msgRef.add(postMsg)
        await firebase.firestore().collection('rooms').doc(selectedRoom?.id)
          .update({
            lastMsg: {
              status: 'seen',
              text: textInput, type: 'file'
            }
          })
        setTextInput('')
        document.getElementById("msg-container").scrollTo({
          top: document.getElementById("msg-container").scrollHeight,
          behavior: 'smooth',
        });
      }
    );

  }


  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setPreview(true)
      setSelectedImage(e.target.files[0]);

    }
  };

  const removeSelectedImage = () => {
    setSelectedImage();
    setPreview(false);
  };

  const linkPattren = /^(http|https):///;
  const textMsg = async () => {
    const msgRef = firebase.firestore().collection('messages');
    const postMsg = {
      text: textInput,
      type: linkPattren.test(textInput) ? 'link' : 'text',
      sender: profile?.uid,
      receiver: selectedRoom.participates.find((d) => d !== profile?.uid),
      createdAt:firebase.firestore.FieldValue.serverTimestamp(),
      roomId: selectedRoom.id,
      read:false,
      status: 'send'
    }
    const addmsg = await msgRef.add(postMsg)
    await firebase.firestore().collection('rooms').doc(selectedRoom?.id)
      .update({
        lastMsg: {
          status: 'seen',
          text: textInput,
          type: 'text'
        },
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      })
    setTextInput('')
    document.getElementById("msg-container").scrollTo({
      top: document.getElementById("msg-container").scrollHeight,
      behavior: 'smooth',
    });
  }
  const onEnter = (e) => {
    //
    if (e.key === 'Enter' && textInput !== '') {
      textMsg();
    }
  }
  const { profile} = useContext(AuthUserContext);
  const Input = styled('input')({
    display: 'none',
  })
  // if(rooms.length===0) return(<Typography>There are no messages :/</Typography>)
  if(noRooms) return (<Box sx={{ width: '100%' }}>
  <LinearProgress />
</Box>)
if(!(rooms && rooms?.length>0))return(
  <>
             <div style={{width:"100%", display:"flex", justifyContent:"center", alignItems:"center", margin:"30vh auto"}}>
              <div>
                <Typography variant="h3" color="primary"
                >There are currently no messages</Typography>
                </div>
                </div>
            </>
  )
  console.log(selectedRoom)
  return <React.Fragment>
    <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
    {/* Hero unit */}
    {/*<TopBar showBar={true}/>*/}
    <Container maxWidth="lg" sx={{textAlign:'left', position:"fixed", right:"10%", left:"10%"}}>
      <Stack direction={'row'} sx={{backgroundColor: '#FBFBFB'}}>
        <Stack direction={'column'} sx={{flex:.25, backgroundColor: '#FBFBFB', overflowY:"scroll"}}>
          <List sx={{ width: '100%',}}>
            {rooms && rooms?.length > 0 &&
              rooms.map((room) => <>
                <ListItemButton  component="a" selected={selectedRoom?.id === room?.id} onClick={() => {
                  selectedRoomCopy = room
                  setSelectedRoom(room)
                }} alignItems="flex-start">
                  <ListItemAvatar>
                    <Avatar alt={room?.participate} src={room?.image} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={room?.participate}
                    secondary={
                      <Stack direction={'column'} spacing={1}>
                        <Typography
                          sx={{color:'#20448895', fontWeight: 100}}
                          variant="body2"

                        >
                          {profile?.userType === "creator" ?
                            <i>{room?.contractId ? room?.projectTitle : "Artist"}</i> : 
                            <i>{room?.projectTitle}</i>
                          }
                          {/* <i>{room?.projectTitle}</i> */}
                        </Typography>
                        {
                          room?.lastMsg &&
                          <Stack direction={'row'}   justifyContent="flex-start"
                                 alignItems="center"
                          >
                            {room?.lastMsg?.status === 'seen' && <DoneAllOutlinedIcon style={{fontSize: 14, marginRight:10, color:'rgba(0, 0, 0, 0.6)'}}/>
                            }
                            <Typography variant="caption" noWrap={true} sx={{maxWidth: 200}} color={'text.primary'}>

                              {room?.lastMsg?.text}
                            </Typography>
                          </Stack>

                        }

                      </Stack>
                    }
                  />



                </ListItemButton>
                <Divider variant="fullWidth" component="li"/>
              </>)

                  }
          </List>
        </Stack>
        <Stack direction={'column'} sx={{flex: showTabs === true ? .5 : .75, height:"85vh", maxWidth:"90vh"}}>
          {selectedRoom && <>
            <Stack direction={'row'} sx={{width: '100%', p: 2, backgroundColor: '#E3E8F0'}}>
              <Stack direction={'row'} sx={{width: '100%', }} justifyContent="flex-start"
                     alignItems="center" spacing={2}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <Avatar alt={selectedRoom?.participate} src={selectedRoom?.image} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={selectedRoom?.participate}
                    secondary={
                      <>
                        <Typography
                          sx={{color:'#20448895', fontWeight: 100}}
                          variant="body2"

                        >
                          {profile?.userType === "creator" ?
                            <i>{selectedRoom?.contractId ? selectedRoom?.projectTitle : "Artist"}</i> : 
                            <i>{selectedRoom?.projectTitle}</i>
                          }
                          {/* <i>{selectedRoom?.projectTitle}</i> */}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
                <IconButton onClick={() => setShowTabs(!showTabs)}>
                  <MoreVertIcon/>
                </IconButton>
              </Stack>
            </Stack>

            {selectedImage && preview &&
            <Stack direction={'column'} spacing={0.5} sx={{width: '100%',flex:1,backgroundColor: '#f9f9f9', overflowY:'hidden'}} id={'msg-container'}>
                  <Box sx={{
                    position:"relative",
                    display: "flex",
                    flex:1,
                    justifyContent: "flex-start",
                    flexDirection:"column",
                    alignItems: "center",
                    // top:"50%",
                    // left:"58%",
                    maxHeight: "100%",
                    width: "100%",

                    }}>
                    <Box direction={'row'} sx={{width: "100%", height:"72px", display: "flex", alignItems: "center", backgroundColor: "#E3E8F0"}}>
                      <IconButton onClick={removeSelectedImage}><CloseIcon/></IconButton>
                      <Box sx={{width: "100%", display: "flex", alignItems: "center", flexDirection: "column"}}>
                      <Typography sx={{fontWeight: 600, fontSize: "16px"}}>{selectedImage.name}</Typography>
                      <Typography sx={{fontSize: "16px", color: "#818488"}}>
                          {selectedImage.size>1000000?
                              <>{Math.round(selectedImage.size*100/(1024*1024))/100} mb</>
                              :
                              <>{Math.round(selectedImage.size/1024)} kb</>
                          }
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{height:"90%", display:"flex", alignItems:"center"}}>

                      {
                        selectedImage.type.split("/")[0]==="image"
                        ?
                        <img src={URL.createObjectURL(selectedImage)} style={{height:"80%", maxWidth:"100%"}} alt="No preview avalaible"/>
                        :
                        <Box sx={{backgroundColor: "#E3E8F0", borderRadius: "20px", height:"75%", width:"735px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems:"center" }}>
                        <img src={'/assets/file.png'} alt="no-preview"/>
                        <Typography sx={{fontSize: "24px", fontWeight: 600, color: "#818488", mt: 2, mb: 2}}>No preview available</Typography>
                        <Typography sx={{fontSize: "16px", color: "#818488"}}>
                          {selectedImage.size>1000000?
                              <>{Math.round(selectedImage.size*100/(1024*1024))/100} mb . {selectedImage.type.split("/")[1]}</>
                              :
                              <>{Math.round(selectedImage.size/1024)} kb . {selectedImage.type.split("/")[1]}</>
                          }
                        </Typography>
                     </Box>
                      }

                    </Box>
                    {/* <Box sx={{width:"100%", display:"flex", justifyContent:"flex-end"}}>
                      {
                         selectedImage.type.split("/")[0]==="image" ?
                          <IconButton color="primary" onClick={(e) => uploadFile('media', selectedImage)}><SendOutlinedIcon/></IconButton>
                          :
                          <IconButton color="primary" onClick={(e) => uploadFile('attachment', selectedImage)}><SendOutlinedIcon/></IconButton>
                      }
                    </Box> */}
                  </Box>
            </Stack>
              }
            {!preview &&
            <Stack direction={'column'} spacing={0.5} sx={{width: '100%',flex:1,p: 2, overflowY:'scroll', backgroundColor: '#f9f9f9'}} id={'msg-container'}>
              {
                messages.length > 0 && messages.map((msg) =>{
                  if(msg?.type === 'created-message') {
                    return(<Box sx={{width: '100%',p: 2, backgroundColor:'#f5f5f5', borderRadius: '5px', textAlign:'center'}}>
                      <Typography variant={'caption'} color={'deepskyblue'}>
                        {msg?.text}
                      </Typography>
                    </Box>);
                  }
                  else if (msg?.type === 'text') {
                    if (msg?.sender === profile.uid) {
                      return(<TextMessageComponent msg={msg} type={'r'} />);
                    } else return (<TextMessageComponent msg={msg} type={'l'} />)
                  } else if (msg?.type!== 'text' && msg?.type !== 'link'){
                    if (msg?.sender === profile.uid) {
                      if (imgExtPattern.test(msg?.file) || videoExtPattern.test(msg?.file)) {
                        return (<MediaFileMessageComponent msg={msg} type={'r'} />)
                      } else {
                        //
                        return (<FileMessageComponent msg={msg} type={'r'} />)
                      }
                    } else {
                      if (imgExtPattern.test(msg?.file) || videoExtPattern.test(msg?.file)) {
                        return (<MediaFileMessageComponent msg={msg} type={'l'} />)
                      } else {
                        //
                        return (<FileMessageComponent msg={msg} type={'l'} />)

                      }
                    }
                  } else if (msg?.type == 'link') {
                    if (msg?.sender === profile.uid) {
                    return  (<LinkMessageComponent msg={msg} type={'r'} />)
                    } else {
                      return  (<LinkMessageComponent msg={msg} type={'l'} />)
                    }
                  }
                })
              }

            </Stack>}
            <Stack direction={'row'} justifyContent="flex-start"
                   alignItems="flex-start" spacing={1} sx={{width: '100%',p:2, backgroundColor: '#E3E8F0'}}>

              <Stack sx={{flex: 1}} spacing={2} direction={'column'}>
                <TextField variant={"outlined"} fullWidth value={textInput} onKeyDown={onEnter} onChange={(e) => setTextInput(e.target.value)} size={'small'} sx={{backgroundColor:'#fff' }}/>
                <Stack direction={'row'} justifyContent="flex-start"
                       alignItems="flex-start" spacing={.5}>
                  <label htmlFor={'image-upload'}>
                    {/* <Input id={'image-upload'} type={'file'} onChange={(e) => uploadFile('media', e.target.files[0])} multiple={false}/> */}
                    <Input id={'image-upload'} type={'file'} onChange={imageChange} multiple={false}/>

                    <IconButton component={'span'} aria-label="image" size="small" color="primary" disabled={ml}>
                      {ml ? <CircularProgress size={20}/> : <BrokenImageOutlinedIcon/>}
                    </IconButton>
                  </label>
                  <label htmlFor={'attachment-upload'}>
                    {/* <Input id={'attachment-upload'} type={'file'} onChange={(e) => uploadFile('attachment', e.target.files[0])} multiple={false}/> */}
                    <Input id={'attachment-upload'} type={'file'} onChange={imageChange} multiple={false}/>

                    <IconButton component={'span'} aria-label="attachment" size="small" color="primary" disabled={al}>
                      {al ? <CircularProgress size={20}/> : <AttachFileOutlinedIcon style={{transform: 'rotate(-130deg)'}}/>}
                    </IconButton>
                  </label>{
                  selectedRoom?.contractId  &&  <label htmlFor={'signed-contract-upload'}>
                  <Input id={'signed-contract-upload'} type={'file'} onChange={(e) => uploadFile('contract', e.target.files[0])} multiple={false}/>
                  <Button component={'span'} variant={'contained'} color={'primary'} size={'small'} sx={{px: 3}}  disabled={cl}>
                    {cl && <CircularProgress size={20}/>}  Upload signed contract
                  </Button>


                </label>}

                </Stack>
              </Stack>
              <IconButton aria-label="send" size="medium" color="primary" disabled={textInput === '' && (selectedImage === undefined)} onClick={!selectedImage ? textMsg :  (selectedImage.type.split("/")[0]==="image" ? ()=>uploadFile('media', selectedImage) : ()=>uploadFile('attachment', selectedImage) )}>

                <SendOutlinedIcon sx={{transform: 'rotate(-40deg)'}}/>
              </IconButton>
            </Stack>

          </>}


        </Stack>
        {showTabs === true &&

          <Stack direction="column"
          justifyContent="flex-start"
          alignItems="flex-end" sx={{flex:.25, height:'calc(100vh - 117px)' }}>
            <IconButton onClick={() => setShowTabs(!showTabs)}>
              <CloseIcon/>
            </IconButton>
            <ChatMediaTabs room={selectedRoom?.id}/>
          </Stack>
        }
      </Stack>
    </Container>

    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth='lg'
    >
      <DialogTitle id="alert-dialog-title" >
        <Stack direction={'row'} spacing={2}>
          <Typography variant={'h6'} sx={{flex:1, textAlign:'center'}} color={'primary'}>The next step</Typography>
          <IconButton color={'primary'} onClick={() => setOpen(false)}>
            <CloseIcon/>
          </IconButton>
        </Stack>


      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" >
          <Typography variant={'body2'}>We will notify you when the contract is verified by the admin.</Typography>
          <Typography variant={'body2'}>Please note that this can take up to 2 weeks.</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{paddingX: 3, paddingY: 2}}>
        <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3, backgroundColor: '#FD4A01', mx: 'auto'}} size={'small'} onClick={() => {
          setOpen(false);
          navigator(`/investor/dashboard`);
        }}>
          GO TO DASHBOARD
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
}
